import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

// @ Sample cache test logging
// console.log('sample response:', response);
// console.log('sample cached:', response.cached);
// console.log('sample ttl:', response.config?.cache?.ttl);
// console.log('sample config:', response.config);
// console.log('sample duration:', response.duration);
// console.log('============================');

//* POST API Partner by user
export const apiPartnerForUser = async () => {
  let response = {};

  try {
    response = await axiosInstance.post(`/trusimapi_partner_for_user`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Update API Partner
export const apiPartnerUpdate = async (body) => {
  let response = {};
  const data = new FormData();
  data.append('data', JSON.stringify(body.payload));
  if (body.logo) {
    data.append('image', body.logo);
  }

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: '/trusimapi_partner_update',
    data,
  };
  try {
    response = await axiosInstance.request(config);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* POST API Partner Promote status
export const apiPartnerPromote = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/trusimapi_partner_promote`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* POST API Partner Production Notification - trigger send email to integrations
export const apiPartnerNotifyProd = async () => {
  let response = {};

  try {
    response = await axiosInstance.post(`/trusimapi_partner_notify`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* POST API Partner Request Additional Licenses
export const apiPartnerRequestLicenses = async (payload) => {
  let response = {};

  try {
    response = await axiosInstance.post(`/trusimapi_partner_add_users`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
